import React, { useEffect, useRef, useState } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { Form, Modal } from 'react-bootstrap';
import { handleDelete, handleSubmit as modalSubmit } from '../../components/modals/ModalHelpers';
import DynModal from '../../components/modals/DynModal';
import ButtonCard from '../../components/cards/ButtonCard';
import ButtonGroup from '../../components/modals/ButtonGroup';
import InputField from '../../components/form/InputField';
import PagedTable from '../../components/table/PagedTable';
import Bivema from '../../common/Bivema';

const columnsQualifications = [
  { title: 'Bezeichnung', name: 'title' },
  { title: 'Edit', name: '_links.self.href' },
];

const defaultQualification = {
  title: '',
};

const qualificationValidationSchema = Yup.object().shape({
  title: Yup.string()
    .max(200, 'Darf maximal 200 Zeichen lang sein.')
    .required('Bitte geben Sie eine Bezeichnung ein.'),
});

const QualificationOverview = () => {
  const [update, setUpdate] = useState(false);
  const [selfLink, setSelfLink] = useState();
  const [showDynModal, setShowDynModal] = useState(false);
  const [classNameDynModal, setClassNameDynModal] = useState('dynModal');

  const [qualification, setQualification] = useState({
    ...defaultQualification,
  });

  // needed for formik, to pass it to the modal and set the values
  const formikRef = useRef();

  // set Tab Title
  useEffect(() => {
    document.title = 'Schulabschluss | Stammdaten';
  }, []);

  useEffect(() => {
    if (qualification._links !== undefined) {
      setSelfLink(qualification._links.self.href);
    }

    // sets formik values
    if (formikRef.current && qualification !== formikRef.current.values) {
      formikRef.current.setValues(qualification);
    }
  }, [qualification]);
  return (
    <div className="container-fluid">
      <ButtonCard title="Schulabschluss" className="mt-2" setShowDynModal={setShowDynModal}>
        <DynModal
          className={classNameDynModal}
          headerTitle="Schulabschluss"
          setEntity={setQualification}
          defaultEntity={defaultQualification}
          settersToReset={[setSelfLink]}
          formikRef={formikRef}
          show={showDynModal}
          setShow={setShowDynModal}
          modalBody={(
            <Formik
              innerRef={formikRef}
              initialValues={qualification}
              onSubmit={(values, submitProps) => modalSubmit(
                values,
                submitProps,
                setUpdate,
                Bivema.QUALIFICATIONS,
                selfLink,
              )}
              validateOnChange={false} // because at the moment on change validates all fields
              validationSchema={qualificationValidationSchema}
            >
              {({
                errors, touched, handleSubmit, handleReset, handleChange, values,
              }) => (
                <Form onSubmit={handleSubmit} onReset={handleReset}>
                  <Modal.Body>
                    <Form.Group controlId="qualification-group">
                      <InputField
                        value={values.title}
                        handleChange={handleChange}
                        touched={touched.title}
                        errorDescription={errors.title}
                        fieldName="title"
                        placeholder="Bezeichnung*"
                      />
                    </Form.Group>
                  </Modal.Body>
                  <Modal.Footer>
                    <ButtonGroup
                      handleDelete={() => handleDelete(selfLink, setUpdate)}
                      selfLink={selfLink !== undefined}
                      setShowDynModal={setShowDynModal}
                      setClassNameDynModal={setClassNameDynModal}
                    />
                  </Modal.Footer>
                </Form>
              )}
            </Formik>
          )}
        />
        <PagedTable
          entityName={Bivema.QUALIFICATIONS}
          columns={columnsQualifications}
          pageSize={10}
          setShowDynModal={setShowDynModal}
          setEntity={setQualification}
          setUpdate={setUpdate}
          update={update}
        />
      </ButtonCard>
    </div>
  );
};

export default QualificationOverview;
